import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import RecipientsScreen from '../../../components/admin/RecipientsScreen';
import { Surface } from '../onboarding/review/contractReviewStyles';

/**
 * Walkthrough finding F-S7-008 (2026-09-23): the recipient register is a maker-checker control whose
 * checker is a risk, compliance or operations user, yet its only screen sat inside the Admin hub,
 * which renders for administrators only — the designed checker could not reach it. This route
 * serves the same screen to every role; the screen shows each user what their role may do, and the
 * server's four-eyes rule decides. Admin → Recipients keeps its tab.
 */
const RecipientsPage: React.FC = () => (
  <Surface>
    <Link to="/portfolio-management/credit/abf/board" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#a6d8f5', textDecoration: 'none', fontSize: 13, margin: '8px 0 12px' }}>
      <ArrowLeft size={14} /> ABF portfolio board
    </Link>
    <RecipientsScreen />
  </Surface>
);

export default RecipientsPage;
